import * as React from 'react';
import { getIdentityProviders, getRoleIdentityProviders, getApplicationPermissions, getClientRoles, getCurrentIdpClients, getCurrentCompany } from '../../ApiUtils/ApiUtils';
import './RoleManagementStyling.css';
import { IdpMapper, KeycloakClient } from '../Management/IdpConfigureForm';
import RoleEditForm from './RoleEditForm';
import RoleCreateForm from './RoleCreateForm';
import RoleDeleteForm from './RoleDeleteForm';
import * as ConsoleStore from '../../store/Console';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { ApplicationState } from '../../store';
import { push } from 'connected-react-router';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner, faTrash } from '@fortawesome/free-solid-svg-icons';
import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';

import { UserProfileContext } from '../Console/ConsoleLayout';
import SupportTeam from '../Console/Dashboard/SupportTeam';
import { isCardContentLoading, CardRoleLoadStatus } from '../../utils';

interface IdPEntity {
    alias: string;
    displayName: string;
    internalId: string;
    providerId: string;
    enabled: boolean;
    updateProfileFirstLoginMode: string;
    trustEmail: boolean;
    storeToken: boolean;
    addReadTokenRoleOnCreate: boolean;
    authenticateByDefault: boolean;
    linkOnly: boolean;
    firstBrokerLoginFlowAlias: string;
    postBrokerLoginFlowAlias: string;
    config: {
        samlXmlKeyNameTranformer: string;
        nameIDPolicyFormat: string;
        syncMode: string;
        singleSignOnServiceUrl: string;
        principalType: string;
        signatureAlgorithm: string;
        useJwksUrl: boolean;
        guiOrder: string;
        [key: string]: any;
    }
}

export interface Role {
    id?: string;
    name: string;
    description: string;
    composite: boolean;
    clientRole: boolean;
    containerId: string;
}

type RoleGridProps = {
    clientProp: KeycloakClient;
    realmName: string;
    adminRealm: string;
    userRealm: string;
    onCreateRole?: () => void;
    // GDSAUTHENTICATOR-realm client list, fetched once by the parent and passed down
    // so each grid can resolve its client locally instead of re-downloading the list.
    gdsAuthClients?: KeycloakClient[];
    // Called once this grid's role fetch settles (success, empty, or failure) so the
    // parent card can hide its loading spinner when both grids have reported.
    onRolesLoaded?: () => void;
}

interface RoleGridState {
    roles: Role[];
    clientId: string;
    clientName: string;
    dialogEditVisible: boolean;
    dialogCreateVisible: boolean;
    dialogDeleteVisible: boolean;
    roleToEdit: Role;
    realmClients: KeycloakClient[];
    selectedRealmClient: KeycloakClient |undefined;
    realmName: string;
    selectedCompanyRealm: string;
}

class GDSAuthRoleGrid extends React.Component<RoleGridProps, RoleGridState> {
    static contextType = UserProfileContext;
    constructor(props: RoleGridProps) {
        super(props);
        this.state = {
            roles: [],
            clientId: "",
            clientName: "",
            dialogEditVisible: false,
            dialogCreateVisible: false,
            dialogDeleteVisible: false,
            roleToEdit: {
                id: "",
                name: "",
                description: "",
                composite: false,
                clientRole: false,
                containerId: ""
            },
            realmClients: [],
            selectedRealmClient: {} as KeycloakClient,
            realmName: this.props.realmName,
            selectedCompanyRealm: this.props.adminRealm
        };
    }

    private _isMounted = false;

    componentDidMount() {
       this._isMounted = true;
       this.loadRolesFromProvidedClients();
    }

    componentWillUnmount() {
       // Guard against the async getRoles resolving after the user navigated away.
       this._isMounted = false;
    }

    private loadRolesFromProvidedClients = () => {
        var gdsAuthClients = this.props.gdsAuthClients ?? [];
        var selectedRealmClient: any = undefined;
        gdsAuthClients.forEach((client: any) => {
            if (client.clientId === this.props.clientProp.clientId) {
                selectedRealmClient = client;
            }
        })

        if (selectedRealmClient) {
            this.getRoles(selectedRealmClient.id, this.props.realmName).then((roles: any) => {
                if (!this._isMounted) return;
                this.setState({
                    realmClients: gdsAuthClients,
                    selectedRealmClient: selectedRealmClient,
                    roles: roles
                })
                this.props.onRolesLoaded && this.props.onRolesLoaded();
            });
        } else {
            // No matching client in this realm: nothing to fetch, but still report so
            // the parent card's spinner does not hang waiting on this grid.
            this.props.onRolesLoaded && this.props.onRolesLoaded();
        }
    }

    private getRoles: any = async (clientID: string, realmName: string) => {
        let promise = new Promise((resolve) => {
            getClientRoles(clientID, realmName).then((dataArray) => {
                var parsed: any = [];
                if (dataArray != '{"error":"Could not find client"}') {
                    try { parsed = JSON.parse(dataArray); } catch (e) { parsed = []; }
                }
                // The backend can return a non-array (e.g. an error object on a 500 / Keycloak
                // hiccup); guard so a failed fetch renders no roles instead of throwing.
                if (Array.isArray(parsed)) {
                    resolve(parsed.filter((r: any) => !r.name.startsWith("admin_company:"))
                        .sort((a: Role, b: Role) => a.name > b.name ? 1 : -1));
                } else {
                    resolve([]);
                }
            }).catch(() => {
                // Request failed (e.g. 500). Render no roles for this client rather than crash/hang.
                resolve([]);
            });
        });

        let result = await promise;
        return result;
    }

    public render() {
        return (
            <>
                <div className="roleBody" style={{float:'left'}}>
                    <p>Default Roles:</p>
                    {this.props.adminRealm == "GDSLINK" && (
                        Array.isArray(this.state.roles) && this.state.roles.map((role, index) => (
                            <div key={role.name + index + "gdslink-body"}>
                                <p className="gds-body inline-tab roleP p-disabled" key={role.name + index}>{role.name} </p>
                            </div>
                        ))
                    )}
                    {this.props.adminRealm != "GDSLINK" && (
                        Array.isArray(this.state.roles) && this.state.roles.map((role, index) => (
                            <div key={role.name + index + "body"}>
                              
                                    <p className="gds-body inline-tab roleP p-disabled" key={role.name + index}>{role.name} </p>
                                
                            </div>
                        ))
                    )}
                </div>
       
            </>
        );
    }
}

class SelectedRealmRoleGrid extends React.Component<RoleGridProps, RoleGridState> {
    static contextType = UserProfileContext;
    constructor(props: RoleGridProps) {
        super(props);
        this.state = {
            roles: [],
            clientId: "",
            clientName: "",
            dialogEditVisible: false,
            dialogCreateVisible: false,
            dialogDeleteVisible: false,
            roleToEdit: {
                id: "",
                name: "",
                description: "",
                composite: false,
                clientRole: false,
                containerId: ""
            },
            realmClients: [],
            selectedRealmClient: {} as KeycloakClient,
            realmName: this.props.realmName,
            selectedCompanyRealm: this.props.adminRealm
        };
    }

    private _isMounted = false;

    componentDidMount() {
        this._isMounted = true;
        var displayedRealm = this.props.realmName;
        if (!displayedRealm || displayedRealm == "") {
            displayedRealm = this.props.userRealm;
        }
        this.getRealmClients(displayedRealm, this.props.userRealm);
    }

    componentWillUnmount() {
        // Guard against the async getRoles resolving after the user navigated away.
        this._isMounted = false;
    }

    private getRealmClients = async (realmName: string, userRealm: string) => {
        // clientProp already comes from this realm's client list (fetched by the parent),
        // so its id is exactly what we need — no need to re-download the whole client list.
        this.getRoles(this.props.clientProp.id, this.props.realmName).then((roles: any) => {
            if (!this._isMounted) return;
            this.setState({
                selectedRealmClient: this.props.clientProp,
                roles: roles
            })
            this.props.onRolesLoaded && this.props.onRolesLoaded();
        });
    }

    private getRoles:any = async (clientID: string, realmName: string) => {
        let promise = new Promise((resolve) => {
            getClientRoles(clientID, realmName).then((dataArray) => {
                var parsed: any = [];
                if (dataArray != '{"error":"Could not find client"}') {
                    try { parsed = JSON.parse(dataArray); } catch (e) { parsed = []; }
                }
                // The backend can return a non-array (e.g. an error object on a 500 / Keycloak
                // hiccup); guard so a failed fetch renders no roles instead of throwing.
                if (Array.isArray(parsed)) {
                    resolve(parsed.filter((r: any) => !r.name.startsWith("admin_company:"))
                        .sort((a: Role, b: Role) => a.name > b.name ? 1 : -1));
                } else {
                    resolve([]);
                }
            }).catch(() => {
                // Request failed (e.g. 500). Render no roles for this client rather than crash/hang.
                resolve([]);
            });
        });

        let result = await promise;
        return result;
    }

    private toggleEditDialog = (name?: string, roleToEdit?: Role, editted?: boolean) => {
        this.setState({
            dialogEditVisible: !this.state.dialogEditVisible,
            clientId: name ?? ''
        });
        if (roleToEdit) {
            this.setState({ roleToEdit: roleToEdit });
            if (editted === true) {
                this.getRealmClients(this.props.realmName, this.props.userRealm);
            }
        }
    };

    private toggleCreateDialog = (name?: string, created?: boolean) => {
        this.setState({
            dialogCreateVisible: !this.state.dialogCreateVisible,
            clientId: name ?? ''
        });
        if (created === true) {
            this.getRealmClients(this.props.realmName, this.props.userRealm);
        }
    };

    private handleCreateRole = (id: string, clientId: string) => {
        this.toggleCreateDialog(this.props.clientProp.id, false);
        this.setState({
            clientId: id,
            clientName: clientId
        });
        this.props.onCreateRole && this.props.onCreateRole();
    };

    private toggleDeleteDialog = (realmClientId?: string, role?: Role, deleted?: boolean) => {
        this.setState({ dialogDeleteVisible: !this.state.dialogDeleteVisible });
        if (role) {
            this.setState({ roleToEdit: role as Role });
            if (deleted === true) {
                
                        this.getRealmClients(this.props.realmName, this.props.userRealm);
                  
            }
        }
    }

    public render() {
        return (
            <div className="roleBody">
                <p>Client Roles:</p>
                {Array.isArray(this.state.roles) && this.state.roles.map((role, index) => (
                    <div className="clientRoleRow" id={role.id + "row"} key={role.name + index + "row"}>
                        <p className="gds-body inline-tab roleP" key={role.name + index} onClick={() => this.toggleEditDialog(this.state.selectedRealmClient?.id, role, false)}>{role.name} </p>
                        <FontAwesomeIcon key={role.name + index + "button"} icon={faTrash} size="1x" onClick={() => this.toggleDeleteDialog(this.state.selectedRealmClient?.id, role, false)} id={role.id + "deleteButton"} />
                        <br />
                    </div>
                ))}
                <hr />
                <button className="btn btn-primary" onClick={() => this.handleCreateRole(this.props.clientProp.id, this.props.clientProp.clientId)}>Create role</button>
                {this.state.dialogEditVisible && (<RoleEditForm toggleDialog={this.toggleEditDialog} clientProp={this.props.clientProp} roleProp={this.state.roleToEdit} realmName = { this.props.realmName } />)}
                {this.state.dialogCreateVisible && (<RoleCreateForm toggleDialog={this.toggleCreateDialog} clientProp={this.props.clientProp} realmName={this.props.realmName} userRealm={this.props.userRealm}/>)}
                {this.state.dialogDeleteVisible && (<RoleDeleteForm toggleDialog={this.toggleDeleteDialog} clientProp={this.props.clientProp} roleProp={this.state.roleToEdit} realmName={this.props.realmName} />)}
                
            </div>);
    }
}

type Props = {}

type RoleListProps = {
} & ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const InitialState: { data: IdPEntity[], domains: string[], idpDisplayNames: string[], idpNames: string[], dialogVisible: boolean, clientId: string, root: boolean, admin: boolean, adminRealm: string, selectedCompanyObject: any, selectedCompany: string | undefined, GdsAuthClients: KeycloakClient[], clientsInSelected: KeycloakClient[], cliRoles: Role[], isLoading: boolean, cardLoadStatus: { [clientId: string]: CardRoleLoadStatus }} = {
    data: [],
    domains: [],
    idpNames: [],
    idpDisplayNames: [],
    dialogVisible: false,
    clientId: "",
    root: false,
    admin: false,
    adminRealm: "",
    selectedCompany: undefined,
    selectedCompanyObject: undefined,
    GdsAuthClients: [],
    clientsInSelected: [],
    cliRoles: [],
    isLoading: false,
    cardLoadStatus: {},
}

type State = typeof InitialState;

class RoleList extends React.Component<RoleListProps, State> {
    static contextType = UserProfileContext;
    public constructor(props: RoleListProps) {
        super(props);
        this.state = {
            data: [],
            domains: [],
            idpNames: [],
            idpDisplayNames: [],
            dialogVisible: false,
            clientId: "",
            root: false,
            admin: false,
            adminRealm: "",
            selectedCompany: undefined,
            selectedCompanyObject: undefined,
            GdsAuthClients: [],
            clientsInSelected: [],
            cliRoles: [],
            isLoading: false,
            cardLoadStatus: {}
        };
        this.handleChange = this.handleChange.bind(this);
        this.getAdminsRealm = this.getAdminsRealm.bind(this);
        this.getRealmClients = this.getRealmClients.bind(this);
        //this.getRoles = this.getRoles.bind(this);
    }
    componentDidMount() {
        //this.getIdps();
        this.setState({ isLoading: true });
        this.getPermissions();
        this.getAdminsRealm();
    }
    private getIdps = async (realmName: string) => {
        await getRoleIdentityProviders(realmName).then((dataArray) => {
            
            //this.setState({ data: JSON.parse(dataArray) });
            var domainArray: string[] = [];
            var nameArray: string[] = [];
            var displayNameArray: string[] = [];
            dataArray.forEach((idp:IdPEntity) => {
                idp.config.guiOrder?.split(',').forEach((domain) => {
                    domainArray.push(domain);
                })
                nameArray.push(idp.alias);
                displayNameArray.push(idp.displayName);
            })
            this.setState({ domains: domainArray, idpNames: nameArray, idpDisplayNames: displayNameArray, data: dataArray})
        });
    }

    private getPermissions = () => {
        var admin = this.state.admin;
        var root = this.state.root;
        getApplicationPermissions().then((dataArray) => {
            dataArray.applications.forEach((perm: any) => {
                if (perm.name === "PortalAdmin@") {
                    if (perm.roles.indexOf("admin") > -1) {
                        admin = true;
                    }
                    if (perm.roles.indexOf("root") > -1) {
                        admin = true;
                        root = true;
                    }
                }
            });
            this.setState({ admin: admin, root: root });
        })
    }

    private getAdminsRealm = () => {
        getCurrentCompany().then((dataArray) => {
            this.setState({ adminRealm: dataArray.company }, () => {
                this.getIdps(dataArray.company).then(() => {
                    if (this.state.admin) {
                        this.getRealmClients(this.state.adminRealm + "_IDP");
                    } else {
                        this.setState({ isLoading: false });
                    }
                }
                )
            })
        })
    }
    private handleChange = (e: DropDownListChangeEvent) => {
        var idpsObjects = this.state.idpNames.map((el: string, i: number) => {

            return { text: this.state.idpDisplayNames[i], value: el }

        });
        var curCompObj = idpsObjects.filter((idp: { text: string, value: string }) => {
            return (idp.value == e.value.value);
        })

        this.setState({
            selectedCompany: e.target.value.value,
            selectedCompanyObject: curCompObj[0]
        }, () => {
            this.getRealmClients(e.value.value);
        })
    }

    //Need to find way to pass current user's realm as realmName here. To call in componentDidMount.
    private getRealmClients = (realmName: string) => {
        getCurrentIdpClients(realmName.slice(0, -4), this.state.adminRealm, true).then((dataArray) => {

            var idpsObjects = this.state.idpNames.map((el: string, i: number) => {

                    return { text: this.state.idpDisplayNames[i], value: el }

            });
            var curCompObj = idpsObjects.filter((e: {text:string,value:string}) => {
                return (e.value == realmName);
            })

            var fetchedClients: KeycloakClient[] = JSON.parse(dataArray);
            if (this.state.admin || this.state.root) {
                // Also load the GDSAUTHENTICATOR client list, compute the intersection, and commit
                // GdsAuthClients + clientsInSelected in a SINGLE setState. Doing this in one render
                // (rather than setting clientsInSelected now and replacing it after the intersection)
                // avoids remounting the client cards and the duplicate role fetches that caused.
                // Removing gds-portal as only root users can edit that client's roles.
                getCurrentIdpClients("GDSAUTHENTICATOR", this.state.adminRealm).then((gdsDataArray) => {
                    var allGdsAuthClients: KeycloakClient[] = JSON.parse(gdsDataArray);
                    var enabledGdsAuthClients: KeycloakClient[] = allGdsAuthClients.filter((client: any) =>
                        client.enabled && client.alwaysDisplayInConsole && client.clientId != "gds-portal"
                    );
                    var gdsAuthClientIds = enabledGdsAuthClients.map((client) => client.clientId);
                    // Admins only see clients that exist in both the selected realm and GDSAUTHENTICATOR.
                    var clientsInSelected = this.state.admin
                        ? fetchedClients.filter((client) => gdsAuthClientIds.indexOf(client.clientId) > -1)
                        : fetchedClients;
                    this.setState({
                        GdsAuthClients: enabledGdsAuthClients,
                        clientsInSelected: clientsInSelected,
                        selectedCompanyObject: curCompObj[0],
                        isLoading: false,
                        // Fresh set of cards → each starts in the loading state until its
                        // two role grids report back via markCardLoaded.
                        cardLoadStatus: {}
                    });
                });
            } else {
                this.setState({ clientsInSelected: fetchedClients, selectedCompanyObject: curCompObj[0], isLoading: false, cardLoadStatus: {} });
            }
        });
    }

    // Record that one of a card's two role grids finished loading. The card keeps
    // showing its spinner until both `default` and `client` sections have reported.
    private markCardLoaded = (clientKey: string, section: keyof CardRoleLoadStatus) => {
        this.setState((prev) => {
            const current = prev.cardLoadStatus[clientKey] || { default: false, client: false };
            if (current[section]) {
                return null;
            }
            return {
                cardLoadStatus: {
                    ...prev.cardLoadStatus,
                    [clientKey]: { ...current, [section]: true }
                }
            } as Pick<State, 'cardLoadStatus'>;
        });
    }

    render() {
        return (
            <>
                <div style={{ margin: "3% 3% 4% 3%" }}>
                    <br /><h3 style={{ display: "inline-block" }}> Roles </h3> <span> {this.state.isLoading && <FontAwesomeIcon icon={faSpinner} size="1x" spin={true} />} </span>
                    <br />
                    {(this.context.permissions.root || this.context.permissions.admin) && (
                        <>
                            <h6 style={{ display: (this.state.idpNames.length > 1 ? "block" : "none") }}>Company:</h6>
                            <DropDownList
                                data={this.state.idpNames.map((el: string, i: number) => { return { text: this.state.idpDisplayNames[i], value: el } })}
                                dataItemKey="value"
                                textField="text"
                                onChange={this.handleChange}
                                style={{ width: "200px", display: (this.state.idpNames.length > 1 ? "block" : "none") }}
                                value={this.state.selectedCompanyObject}
                            />
                            <br />
                            <br />
                            {this.state.clientsInSelected && (
                                <>
                                    {this.state.clientsInSelected.map((client, i) => {
                                        const cardLoading = isCardContentLoading(this.state.cardLoadStatus[client.id]);
                                        return (
                                        <div key={client.id + "div"} >
                                            <div className="card" key={client.id + "card"} >
                                                <div className="card-body" key={client.id + i + "body"}>
                                                    <h2 key={client.id + i + "h2"} className="clientHeader"> {client.clientId} </h2>
                                                    {cardLoading && (
                                                        <div className="cardRolesLoading" style={{ textAlign: "center", padding: "24px 0" }}>
                                                            <FontAwesomeIcon icon={faSpinner} size="2x" spin={true} />
                                                        </div>
                                                    )}
                                                    {/* Keep the grids mounted (so they fetch) but hidden until both report loaded. */}
                                                    <div style={{ display: cardLoading ? "none" : "block" }}>
                                                        <GDSAuthRoleGrid clientProp={client} realmName="GDSAUTHENTICATOR" adminRealm={this.state.selectedCompanyObject.value.slice(0, -4)} userRealm={this.state.adminRealm} gdsAuthClients={this.state.GdsAuthClients} onRolesLoaded={() => this.markCardLoaded(client.id, "default")} />
                                                        <SelectedRealmRoleGrid clientProp={client} realmName={this.state.selectedCompanyObject.value.slice(0, -4)} adminRealm={this.state.selectedCompanyObject.value.slice(0, -4)} userRealm={this.state.adminRealm} onRolesLoaded={() => this.markCardLoaded(client.id, "client")} />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        );
                                    })}
                                </>
                            )}
                        </>
                    )}

                </div>
                <div className="support-footer" style={{ width: "100%" }}>
                    <SupportTeam></SupportTeam>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state: ApplicationState) => {
    return {
        console: state.console,
        router: state.router
    }
}

const mapDispatchToProps = (dispatch: Dispatch) => {
    return {
        push: (path: string) => dispatch(push(path)),
        consoleActions: bindActionCreators(ConsoleStore.actionCreators, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoleList);